import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import './index.css'
import { AuthProvider } from './context/AuthContext.jsx'
import { registerSW } from 'virtual:pwa-register'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN || "https://59b00a5e224fe309bfd041c4132eb612@o4512243076759552.ingest.de.sentry.io/4512243086000208";
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "Can't find variable: $pld",
      /Can't find variable: \$pld/,
      /^ResizeObserver loop limit exceeded/,
      /^ResizeObserver loop completed with undelivered notifications/,
      /Non-Error promise rejection captured/,
      /reCAPTCHA has already been rendered in this element/i,
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome-extension:\/\//i,
      /^safari-web-extension:\/\//i,
      /^moz-extension:\/\//i,
    ],
  });
}

// Enregistrement du Service Worker pour la PWA
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateSW(true);
  },
});

if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
